import { investments } from "../../data/data";
import { Link } from "react-router-dom";
import { useGlobalContext } from "../../context/context";

// IMAGES
import ClientSupport from "../../assets/client-support.webp";
import Security from "../../assets/security.webp";
import { useEffect } from "react";

const Services = () => {
  const { resetPage } = useGlobalContext();

  useEffect(() => {
    resetPage(`Services`);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <section className='services'>
        <article className='header'>
          <h4>INVESTMENTS</h4>
          <h2>
            GeminiTetherChain has various investment plans to fuel your finance
            and business.
          </h2>
          <p>
            GeminiTetherChain is one of the longest running, most trusted and
            healthiest platforms. Our clients benefit from industry-leading
            cryptocurrency pairs, deep market access, and direct access to
            Principal OTC desks and futures exchanges. <br />
            <br />
            Through multiple international partners, customers enjoy fiat and
            cryptocurrency financing options with high monthly limits, including
            fiat financing in seven global currencies. For the most efficient
            transaction execution, we have extended the rate limit for clients
            trading algorithms using either REST or the WebSocket API.
          </p>
        </article>
        <div className='investments'>
          {investments.map((investment, index) => {
            const { name, logo, info } = investment;
            return (
              <div className='item' key={index}>
                <div className='logo'>
                  <img src={logo} alt={name} />
                </div>
                <h3>{name}</h3>
                <p>{info}</p>
              </div>
            );
          })}
        </div>
        <article className='client-support'>
          <div className='text'>
            <h4>CLIENT SUPPORT</h4>
            <h2>Expert support for professional & institutional traders</h2>
            <p>
              GeminiTetherChain provides 24/7 access to a dedicated
              institutional relationship and account management team via email,
              phone, or any of these recommended encrypted messaging services..{" "}
              <br />
              <br /> Whether you&apos;re a family office, broker, high frequency
              dealer, or , we offer the most personalized service in the
              industry. GeminiTetherChain personnel are assigned based on your
              specific needs based on , so you can find the best person to help
              you every time.
            </p>
          </div>
          <div className='image'>
            <img src={ClientSupport} alt='client support' />
          </div>
        </article>
        <article className='security'>
          <div className='image'>
            <img src={Security} alt='client support' />
          </div>
          <div className='text'>
            <h4>SECURITY</h4>
            <h2>GeminiTetherChain sets the industry standard for security.</h2>
            <p>
              Security is at the heart of GeminiTetherChain&apos; DNA, which is
              why it has an impeccable security record after more than a decade
              of business. As a cryptocurrency native organization,
              GeminiTetherChain&apos; long-standing reputation for continues to
              set the industry standard with a focus on security through
              extensive controls designed to prevent theft of financial assets
              or information. <br />
              <br />
              As a result, clients have outsourced billions of dollars worth of
              on-chain assets to us, including ETH2 locked into staking, which
              is longer than any other peer exchange.
            </p>
          </div>
        </article>
        <article className='contact-box'>
          <p>
            GeminiTetherChain&apos; organizational relationship and solutions
            team is made up of experts to meet all your needs in the
            ever-growing and complex world of cryptocurrencies.
          </p>
          <br />
          <br />
          <p>
            Contact us at <span>support@geminitetherchain.com</span> and someone
            from our team will reach directly
          </p>
          <div className='btn'>
            <Link href='/contact'>
              <button className='purple'>Contact us</button>
            </Link>
          </div>
        </article>
      </section>
    </>
  );
};

export default Services;
